import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Elements } from "@stripe/react-stripe-js";
import { CardContent } from "@mui/material";
import { stripePromise } from "stripe";
import { useHistory } from "react-router-dom";
import usePurchaseSelector from "redux/selectors/purchaseSelectors";
import { Typography } from "components/Shared/Typography";
import CheckoutForm from "../checkoutForm";
import RoutePaths from "routes/RoutePaths";
import { Card } from "components/Shared/Card";
import { calculateTotalAmountForPoint } from "utils/payment";
import "./styles.scss";

interface Props {
  handleOnSuccessfulCheckout: () => void;
  handleClose: () => void;
}
const PurchaseArea: FC<Props> = ({
  handleOnSuccessfulCheckout,
  handleClose,
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  const { pointsPlanToPurchase } = usePurchaseSelector();

  useEffect(() => {
    if (!pointsPlanToPurchase) {
      history.push(RoutePaths.studentPurchasePoints);
    }
  }, []);

  return (
    <div className="point-purchase">
      <Card>
        <CardContent className="card-content">
          <div className="header-row">
            <div className="col-left">
              <Typography variant="" className="sub_heading" component="div">
                {t("purchaseArea.title")}
              </Typography>
              <Typography variant="" className="sub_heading" component="div">
                {`${pointsPlanToPurchase?.amount} ${t(
                  "purchaseArea.label.points"
                )}`}
              </Typography>
            </div>
            <div className="col-right">
              {t("purchaseArea.label.JPY")}
              <span>{calculateTotalAmountForPoint(pointsPlanToPurchase)}</span>
            </div>
          </div>
          <div className="">
            <Elements stripe={stripePromise}>
              <CheckoutForm
                pointsPlanToPurchase={pointsPlanToPurchase}
                onSuccessfulCheckout={handleOnSuccessfulCheckout}
                handleClose={handleClose}
              />
            </Elements>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PurchaseArea;
